export enum EngagementMeetingStatus {
    Upcoming = 1,
    InProgress = 2,
    Completed = 3,
    // [#1305] Kept for refunds, history and audit; the API leaves it out of every meetings list.
    Cancelled = 4,
}
